import { Component, inject, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { InternalToolbar } from '../../components/internal-toolbar/internal-toolbar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReactiveIconTextButton } from '../../components/reactive-icon-text-button/reactive-icon-text-button';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TAGImageCategory } from '../../../models/tagimagecategory';
import { ApiService } from '../../api.service';
import { SkeletonModule } from 'primeng/skeleton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FieldsetModule } from 'primeng/fieldset';
import { TAGConfig } from '../../../models/tagconfig';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'app-internal-settings',
  imports: [
    InternalToolbar,
    TranslatePipe,
    ReactiveIconTextButton,
    ReactiveFormsModule,
    DividerModule,
    SelectModule,
    TextareaModule,
    FloatLabelModule,
    SkeletonModule,
    ToggleSwitchModule,
    FieldsetModule,
    InputNumberModule,
  ],
  providers: [TranslateService],
  templateUrl: './internal-settings.html',
  styleUrl: './internal-settings.scss',
})
export class InternalSettings {
  //private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  //private router = inject(Router);
  //private route = inject(ActivatedRoute);
  public api = inject(ApiService);

  settingsForm = new FormGroup({
    enableSongRequests: new FormControl(false),
    songRequestTimeouts: new FormControl(5 * 60),
    defaultGallery: new FormControl(undefined),
    enableSchulradio: new FormControl(false),
    allowGroupsForBookIn: new FormControl(false),
    allowReturnItemsNotInTransaction: new FormControl(false),
    allowItemRebooking: new FormControl(false),
    labelTemplate: new FormControl(''),
    groupLabelTemplate: new FormControl(''),
  });

  imageCategories = signal<TAGImageCategory[]>([]);
  loadingCategories = signal(true);

  isSaving = signal(false);

  ngOnInit() {
    this.api.waitForAPI().then(() => {
      this.settingsForm.patchValue(this.api.config());

      this.api
        .getImageCategories()
        .then((categories: TAGImageCategory[]) => {
          this.imageCategories.set(categories);
          this.loadingCategories.set(false);
        })
        .catch((reason) => {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.translate('errors.couldNotLoadImageCategories')(),
            detail: reason.message,
          });
        });
    });
  }

  revertSettings() {
    this.settingsForm.patchValue(this.api.config());
  }

  saveSettings() {
    console.log(this.settingsForm.value);

    if (this.settingsForm.invalid) return;

    this.isSaving.set(true);

    let config = new TAGConfig(this.api.config().serialize());
    config.deserialize(this.settingsForm.value);
    this.api.config.set(config);

    this.api
      .saveConfig()
      .then((result) => {
        this.settingsForm.patchValue(this.api.config());
        this.isSaving.set(false);
        this.settingsForm.markAsUntouched();
      })
      .catch((reason) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.translate('errors.couldNotSaveSettings')(),
          detail: reason?.message,
        });
        this.isSaving.set(false);
      });
  }
}
